export enum FormControlVisibleValueBlock {
  Root = 'FormControlVisibleValue',
}

export enum FormControlVisibleValueElement {
  Title = 'title',
  DisplayValue = 'displayValue',
  Delete = 'delete',
}
